/********************************************
 * Process Slider
*
* Flickity carousel
* https://flickity.metafizzy.co/
********************************************/
function fnSustainableCarousel( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection				= $( oSection ),
		oCarousel				= $( '.slider', oSection ),
		oArrows					= $( 'nav.arrows', oSection ),
		oBar					= $( '.progress-bar', oSection ),
		iCurrentSlide;


	/*****************
	* Carousel configuration
	*****************/

	/**
	* Initialise Flickity
	*/
	var $oFlickity				= oCarousel.flickity({
		cellAlign: 					'center',
		fade: 						false,
		freeScroll: 				false,
		contain: 					false,
		accessibility: 				false,
		prevNextButtons: 			false,
		pageDots: 					false
	});

	/**
	* Store carousel data
	*/
	var aCarouselData			= $oFlickity.data( 'flickity' ),
		iTotalSlides			= aCarouselData.slides.length;

	/**
	* Arrow buttons (prev/next)
	*/
	oArrows.find( 'i.next' ).on( 'click', function() {
		$oFlickity.flickity( 'next' );
	});
	oArrows.find( 'i.prev' ).on( 'click', function() {
		$oFlickity.flickity( 'previous' );
	});

	/**
	* Progress bar
	*/
	// Update progress bar on load
	oBar.find( '.current' ).css( 'width', ( 100 / ( iTotalSlides ) ) * 1 + '%' );

	// On scroll
	$oFlickity.on( 'scroll.flickity', function( event, iProgress ) {

		// Current slide
		iCurrentSlide			= aCarouselData.selectedIndex + 1;

		// Calculate progress
		iSlideBarWidth			= 100 / ( iTotalSlides );
		iProgress				= ( iCurrentSlide * iSlideBarWidth );

		// Update progress bar
		oBar.find( '.current' ).css( 'width', iProgress + '%' );

	});

	/**
	* Update cellAlign based on screen width
	*/
	function updateCellAlign() {
		var newAlign = window.innerWidth <= 860 ? 'left' : 'center';
		$oFlickity.flickity('option', { cellAlign: newAlign });
		$oFlickity.flickity('reloadCells');
	}

	// Initial check
	updateCellAlign();

	// Update on window resize
	$(window).on('resize', updateCellAlign);

}


// END OF DOCUMENT
